export const quickViewStore = () => ({
  isOpen: false,
  openProductUrl: null,

  init() {
    this.isOpen = false;
    this.openProductUrl = null;
  },

  toggle(url) {
    if (url) {
      this.openProductUrl = url;
      this.isOpen = true;
    } else {
      this.openProductUrl = null;
      this.isOpen = false;
    }
  }
});
